var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"col-12 d-flex justify-content-between py-4"},[_c('div',[_c('h2',{staticClass:"mb-0"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }